// Signing & verification (ARCHITECTURE.md §4 "signed by default").
// ECDSA over P-256 with SHA-256. Signatures are raw r||s (64 bytes).

import { importVerifyKey } from './keys';

const subtle = globalThis.crypto.subtle;
const ALG = { name: 'ECDSA', hash: 'SHA-256' } as const;

export async function sign(signPrivate: CryptoKey, message: Uint8Array): Promise<Uint8Array> {
  const sig = await subtle.sign(ALG, signPrivate, message);
  return new Uint8Array(sig);
}

export async function verify(
  signPublicRaw: Uint8Array,
  signature: Uint8Array,
  message: Uint8Array,
): Promise<boolean> {
  const key = await importVerifyKey(signPublicRaw);
  return subtle.verify(ALG, key, signature, message);
}
